import EditPersonalInformation from './EditPersonalInformation.page';

export default EditPersonalInformation;
